import { useCallback, useEffect, useState } from "react";
import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";

/**
 * CopyColetaPrecoFornecedorModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  fornecedoresDropdown: FornecedorDropDown[];
  onClose: () => void;
  onSubmit: (idFornecedor: number) => void;
};

export const CopyColetaPrecoFornecedorModal = ({
  open,
  saving,
  loading,
  fornecedoresDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const [selectedIdFornecedor, setSelectedIdFornecedor] = useState<number>();

  useEffect(() => {
    if (open) {
      setSelectedIdFornecedor(undefined);
    }
  }, [
    open,
  ]);

  const handleSubmit = useCallback(() => {
    if (selectedIdFornecedor !== undefined && selectedIdFornecedor !== null) {
      onSubmit(selectedIdFornecedor);
    }
  }, [
    selectedIdFornecedor,
    onSubmit,
  ]);

  return (
    <BaseControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Copiar"
      onClose={onClose}
      onSubmit={handleSubmit}>
      <div className="w-full py-2">
        <DefaultAutocomplete
          label="Fornecedor"
          options={fornecedoresDropdown}
          getOptionKey={x => x.idFornecedor}
          getOptionLabel={x => x.nomeFantasia}
          value={fornecedoresDropdown.find(x => x.idFornecedor === selectedIdFornecedor)}
          onChange={e => setSelectedIdFornecedor(e !== null ? e.idFornecedor : undefined)}
        />
      </div>
    </BaseControlledModal>
  );
}